import type { EmailLabel } from '@/lib/inboxLabelsApi';

interface LabelChipProps {
  label: Pick<EmailLabel, 'name' | 'colour'>;
  removable?: boolean;
  onRemove?: () => void;
  size?: 'sm' | 'md';
}

export function LabelChip({ label, removable, onRemove, size = 'sm' }: LabelChipProps) {
  const fontSize = size === 'sm' ? 11 : 12;
  const padding = size === 'sm' ? '2px 7px' : '3px 9px';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: label.colour + '22', // 13% opacity fill
        border: `1px solid ${label.colour}66`, // 40% opacity border
        color: label.colour,
        fontFamily: "'IBM Plex Sans', sans-serif",
        fontSize,
        fontWeight: 500,
        padding,
        borderRadius: 10,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: label.colour,
          flexShrink: 0,
        }}
      />
      {label.name}
      {removable && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            color: label.colour,
            fontSize: 12,
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            opacity: 0.7,
          }}
          title={`Remove label "${label.name}"`}
        >
          ×
        </button>
      )}
    </span>
  );
}
